<template>
  <div class="pageStyle">
    <!-- 全屏loading遮罩 -->
    <div class="loading-mask" v-show="isLoading">
      <div class="loading-content">
        <div class="loading-spinner"></div>
        <div class="loading-text">页面加载中...</div>
      </div>
    </div>
    <div class="content">
      <div
        class="item"
        :class="{ 'slide-in-item': startAnimation }"
        v-for="(item, index) in list"
        :key="index"
        :style="startAnimation ? { animationDelay: index * 0.2 + 's' } : {}"
      >
        <div class="top">
          <div>{{ item.title }}</div>
          <div>{{ item.desc }}</div>
        </div>
        <div class="bottom">
          <div
            class="bottom-item"
            v-for="(module, moduleIndex) in item.module"
            :key="moduleIndex"
            @click="toPage(module.url)"
          >
            <div class="bottom-left">
              <img :src="module.icon" alt="" />
            </div>
            <div class="bottom-right">
              <div>
                <span>{{ module.title }}</span>
                <span>{{ module.desc }}</span>
              </div>
              <div>
                <img
                  src="https://static.xchengtech.cn/6d81cb6fd9644fab8214677f706ef655.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon, Toast } from "vant";
import Cookies from "js-cookie";
import { getDepNameByDomain } from "@/utils/index.js";
Vue.use(Icon);
Vue.use(Toast);
export default {
  created() {
    // 功能卡片 滑动动画
    this.startAnimation = true;
    this.getDepName();
  },
  data() {
    return {
      isLoading: false, // 全屏loading状态
      startAnimation: false, // 控制卡片动画开始
      isCreating: false,
      // 产品列表 通用渠道id：eb750ee04a834b1ca6839aedda60f54d"
      list: [
        {
          title: "基础合规",
          desc: "赋能第三方机构参与预算绩效管理实践",
          module: [
            {
              title: "财税报告",
              desc: "个人/企业全方位数据分析及详尽报告",
              icon: "https://static.xchengtech.cn/0ca68f284c204da0bd3de8412d5ffad4.png",
              url: "https://xccompanyrepo.xchengtech.cn/#/reportList?priceCode=47916a25afb94d2590091e02eccbcb74&channelId=",
            },
            {
              title: "企业测额",
              desc: "在线测额精准匹配产品",
              icon: "https://static.xchengtech.cn/c916da5b336347ee93a13bfb938eef8b.png",
              url: "https://page.xchengtech.cn/productPage/qyce.html?channelId=",
            },
            {
              title: "补贴信息",
              desc: "提供各类补贴信息及规划",
              icon: "https://static.xchengtech.cn/8c812318a303420d8eb5fbacb57a894d.png",
              url: "https://independentpage.xchengtech.cn/productPage/czpt.html?channelId=",
            },
          ],
        },
        {
          title: "快速成长",
          desc: "卓越绩效领航 · 夯实管理根基 · 赋能企业进阶",
          module: [
            {
              title: "融资建议",
              desc: "线上线下融资产品定制化金融产品",
              icon: "https://static.xchengtech.cn/8edd4017b8614f059785874f0cf9baad.png",
              //   url: "https://hpmra.xchengtech.cn",
            },
            {
              title: "债务优化",
              desc: "个人债务 / 结构 / 期限 / 还款方式全面优化降低成本",
              icon: "https://static.xchengtech.cn/be557ddc30ef42428ceb584d37834992.png",
              url: "https://independentpage.xchengtech.cn/productPage/zwyh.html?channelId=",
            },
            {
              title: "资产配置",
              desc: "境内外保险理财投资等服务",
              icon: "https://static.xchengtech.cn/d1c2e753bcdc4199820ce61853fe2d46.png",
              url: "https://independentpage.xchengtech.cn/productPage/zcpz.html?channelId=",
            },
          ],
        },
        {
          title: "卓越经营",
          desc: "卓越绩效领航 · 夯实管理根基 · 赋能企业进阶",
          module: [
            {
              title: "账户管理",
              desc: "资金结算支付清分等管理系统解决方案",
              icon: "https://static.xchengtech.cn/ad634edd6f61496cacde93a56c66a7ca.png",
              url: "https://independentpage.xchengtech.cn/productPage/zhgl.html?channelId=",
            },
            {
              title: "信用修复",
              desc: "专业合规修复负面信息信用 重塑商机重启",
              icon: "https://static.xchengtech.cn/ecc11c6b32c140a886024a6780d0289a.png",
              url: "https://h5.besodata.com/#/pages/creditRepair/home?tenantCode=xcsz&platform=HXFY",
            },
            {
              title: "资产配置（ 高级 ）",
              desc: "境内外保险理财投资等服务",
              icon: "https://static.xchengtech.cn/9c48b6fe9d9b4149bbbb664e724b7308.png",
              url: "https://independentpage.xchengtech.cn/productPage/zcpz.html?channelId=",
            },
          ],
        },
      ],
      depName: "",
      channelId: this.$route.query.channelId,
    };
  },
  methods: {
    getDepName() {
      this.depName = getDepNameByDomain();
    },
    toPage(url) {
      if (url) {
        const toast = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
          overlay: true,
        });
        // 延迟一小段时间后跳转，让用户看到加载提示
        setTimeout(() => {
          toast.close();
          // 如果url中包含channelId=，则替换为当前channelId
          if (url.includes("channelId=")) {
            let o = url + this.channelId;
            window.location.href = o;
          } else {
            window.location.href = url;
          }
        }, 300);
      } else {
        Toast("敬请期待");
      }
    },
  },
};
</script>

<style scoped>
/* 图标地址：https://www.iconfont.cn/collections/detail?spm=a313x.collections_index.i1.d9df05512.58b93a814eYZym&cid=53415 */

/* 全屏loading样式 */
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2770f1;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px;
}

.loading-text {
  color: #2770f1;
  font-size: 14px;
  font-weight: 500;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 卡片滑入动画 */
.slide-in-item {
  opacity: 0;
  transform: translateX(-100px);
  animation: slideInLeft 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

@keyframes slideInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100px) scale(0.9);
  }
  60% {
    opacity: 0.8;
    transform: translateX(10px) scale(1.02);
  }
  100% {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}
.pageStyle {
  font-family: "黑体";
  padding-top: 47vw;
  background: url("https://static.xchengtech.cn/eb63530826cf43a58a7e63a2dab2ad9b.jpg");
  background-repeat: no-repeat;
  background-size: 100% auto;
  width: 100%;
  background-color: #caf0fd;
  min-height: 100vh;
  font-size: 3.6vw;
  padding-bottom: 17vw;
}
.content {
  display: grid;
  gap: 4vw;
  padding: 4vw;
}
.content .item {
  display: grid;
  gap: 4vw;
  border-radius: 12px;
  padding: 5vw 4vw;
  background-color: white;
  box-shadow: 0 4px 12px #c7e3fa;
}
.content .item .top {
  display: grid;
  gap: 2vw;
}

.content .item .top div:nth-of-type(1) {
  display: flex;
  align-items: center;
  gap: 2vw;
  font-weight: 600;
  font-size: 4.8vw;
  color: #2a4067;
}

.content .item .top div:nth-of-type(2) {
  color: #aab3c4;
  font-size: 4vw;
}

.content .item .bottom {
  display: grid;
  gap: 4vw;
}
.content .item .bottom .bottom-item {
  display: flex;
  align-items: center;
  gap: 4vw;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 3vw 3vw;
  transition: all 0.3s ease;
  cursor: pointer;
}
.content .item .bottom .bottom-left img {
  display: block;
  height: 5vw;
  padding-left: 2vw;
}
.content .item .bottom .bottom-right {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2vw;
}
.content .item .bottom .bottom-right img {
  display: block;
  height: 3.6vw;
}
.content .item .bottom .bottom-right span {
  display: block;
}
.content .item .bottom .bottom-right span:nth-of-type(1) {
  font-weight: 600;
  font-size: 3.8vw;
  color: #2a4067;
  margin-bottom: 1vw;
}
.content .item .bottom .bottom-right span:nth-of-type(2) {
  font-size: 3.4vw;
  color: #aab3c4;
}
</style>


// WEBPACK FOOTER //
// src/view/reportCommon/enterpriseServices.vue